module.exports = require("core-js-pure/features/array/is-array");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/array/is-array.js
// module id = 342
// module chunks = 0